import './RetailTracAndWorkplaceOnlyPage.scss';

import React from 'react';
import {
  workplaceRetirementAccountsUrl,
  fundResearchUrl
} from 'services/Externals';
import Content from 'services/Content';
import { externalAuthorizationTracPath } from 'services/ExternalAuthorizationURLBuilder';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import { connect } from 'react-redux';
import { AAMBeaconButton } from 'components/shared/Beacon';

const RetailTracAndWorkplaceOnlyPage = ({isCustomerWebView}) => (
  <div className="error-page-wrapper retial-workplace-wrapper">
    <div className="retail-error-page-container">
      <div className="retail-workplace-page-main-container">
        <div className="retail-workplace-page-button-container">
          <div className={'retail-error-page-content-left'}>
            <div className="retail-error-page-message-container">
              <div className="retail-error-page-title trac-wrk-account-error-page-title">
                Looking for Your Workplace Retirement Account?
              </div>
              <AAMBeaconButton
                id={'link-button-workplace-retirement'}
                linkHref={workplaceRetirementAccountsUrl}
                linkTarget="_blank"
                variant={'primary'}
                scale={'jumbo'}
                disabled={isCustomerWebView}
              >
                Go to Workplace Retirement
              </AAMBeaconButton>
            </div>
          </div>
          <div className={'retail-error-page-content-right'}>
            <div className="retail-error-page-message-container">
              <div className="retail-error-page-title trac-wrk-small-account-error-page-title">
                Looking for Your Small Business Retirement Plan Account?
              </div>
              <AAMBeaconButton
                id={'link-button-small-business-retirement'}
                linkHref={externalAuthorizationTracPath}
                linkTarget="_blank"
                variant={'primary'}
                scale={'jumbo'}
                disabled={isCustomerWebView}
              >
                Go to Small Business Retirement Plan
              </AAMBeaconButton>
            </div>
          </div>
        </div>
        <div className="open-an-account-container">
          <span>{Content.rpsOnlyAccountsMessage}</span>
          <div className="open-personal-account">
            <a href={fundResearchUrl}>Open Personal Investing Account</a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  isCustomerWebView: getCustomerWebView(state)
});

export default connect(mapStateToProps)(RetailTracAndWorkplaceOnlyPage);
